// src/apiClient.js
import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

// ✅ Fallback to your production API if env var is missing
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.yoursmartcv.com";

if (!process.env.REACT_APP_API_BASE_URL) {
  console.warn(
    "REACT_APP_API_BASE_URL not set – using https://api.yoursmartcv.com as default"
  );
}

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 580000,
});

// Return Authorization header if user is signed in, otherwise {}
async function getAuthHeaders() {
  try {
    const session = await fetchAuthSession();
    console.log("fetchAuthSession session:", session);

    const idToken = session?.tokens?.idToken?.toString();

    // if (!idToken) {
    //   console.warn("No idToken – user probably not signed in");
    //   return {};
    // }

    if (!idToken) {
      // user not signed in -> don't call protected billing endpoints
      return null; // important signal
    }

    console.log("Using idToken:", idToken.slice(0, 25) + "...");

    return { Authorization: `Bearer ${idToken}` };
  } catch (err) {
    console.warn("Error getting auth token", err);
    return {};
  }
}


// Generic GET helper
// export async function apiGet(path, config = {}) {
//   const headers = {
//     ...(await getAuthHeaders()),
//     ...(config.headers || {}),
//   };
//   return api.get(path, { ...config, headers });
// }

export async function apiGet(path, config = {}) {
  const authHeaders = await getAuthHeaders();

  // If this is a protected billing endpoint and no token -> stop early
  if (!authHeaders && path.startsWith("/billing")) {
    const err = new Error("Not signed in");
    err.response = { status: 401 };
    throw err;
  }

  const headers = {
    ...(authHeaders || {}),
    ...(config.headers || {}),
  };

  return api.get(path, { ...config, headers });
}

// Generic POST helper
// export async function apiPost(path, data, config = {}) {
//   const headers = {
//     "Content-Type": "application/json",
//     ...(await getAuthHeaders()),
//     ...(config.headers || {}),
//   };
//   return api.post(path, data, { ...config, headers });
// }

export async function apiPost(path, data, config = {}) {
  const authHeaders = await getAuthHeaders();

  // If this is a protected billing endpoint and no token -> stop early
  if (!authHeaders && path.startsWith("/billing")) {
    const err = new Error("Not signed in");
    err.response = { status: 401 };
    throw err;
  }

  const headers = {
    "Content-Type": "application/json",
    ...(authHeaders || {}),
    ...(config.headers || {}),
  };

  return api.post(path, data, { ...config, headers });
}

export default api;
